import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { Button } from '../../root/components/common'
import Icon from '@mdi/react'
import { mdiCheckCircleOutline } from '@mdi/js'
const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 32px 32px 32px',
        alignItems: 'center',
        gap: '1rem',
        width: '385px',
        borderRadius: '1rem',
        border: '1px solid #EAECF0',
        boxShadow:
            '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)'
    },
    label: { padding: '4px 12px', borderRadius: '1rem', background: '#f8f8f8' },
    title: {
        fontSize: '2rem',
        fontWeight: 600,
        lineHeight: '47px',
        textAlign: 'center'
    },
    description: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        textAlign: 'center'
    },
    features: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        borderTop: '1px solid #EAECF0',
        padding: '2rem',
        flex: 1
    },
    feature: {
        display: 'flex',
        gap: '12px',
        fontSize: '1rem',
        lineHeight: '1.5rem'
    },
    iconWrapper: {
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    btn: { width: '100%' }
}))

export default function HotSwapOptionCard({ handleBtnClick, swapType }) {
    const classes = useStyles()
    const { locale, theme } = useSelector(state => state.main)
    const text = locale.hotSwap[swapType]
    return (
        <div className={classes.wrapper}>
            <div className={classes.label}>{text.label}</div>
            <div className={classes.title}>{text.title}</div>
            <div className={classes.description}>{text.description}</div>
            <div className={classes.features}>
                {Object.keys(text.features).map(key => (
                    <div key={text.features[key]} className={classes.feature}>
                        <div className={classes.iconWrapper}>
                            <Icon
                                path={mdiCheckCircleOutline}
                                size={1}
                                color={theme.checkIconColor}
                            />
                        </div>
                        {text.features[key]}
                    </div>
                ))}
            </div>
            <Button onClick={handleBtnClick} className={classes.btn}>
                {text.btnText}
            </Button>
        </div>
    )
}
